import { TRUE_STATUS, FALSE_STATUS} from "../actions/ChangedAction"

const initialState = {
  isChange: true,
};

const statusReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRUE_STATUS:
      return { ...state, isChange: true };
    case FALSE_STATUS:
      return { ...state, isChange: false };
    default:
      return state;
  }
};

export default statusReducer;